import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import {
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import TutorialCardPreview from './TutorialCardPreview';
import CreateTutorialForm from './CreateTutorialForm';
import TutorialsService from '../../../services/TutorialsService';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const CreateTutorialView = ({ edit }) => {
  const classes = useStyles();
  const { id } = useParams();
  const [hasImage] = useState(false);
  const [tutorial, setTutorial] = useState({
    id: null,
    title: '',
    description: '',
    url: '',
    app: '',
    is_available: false,
    preview_image: ''
  });

  const inputRef = useRef();

  const handleStateAttributes = (values) => {
    setTutorial({
      ...tutorial,
      ...values
    });
  };

  const handleUploadImage = () => inputRef.current.click();

  useEffect(() => {
    if (id) {
      (async () => {
        const response = await TutorialsService.getById(id);
        if (response?.code === 200) {
          setTutorial({
            ...response.data,
            id: response.data.id,
            title: response.data.title,
            description: response.data.description,
            url: response.data.url,
            app: response.data.app,
            is_available: response.data.is_available,
          });
        }
      })();
    }
  }, [id]);

  return (
    <Page
      className={classes.root}
      title="Crear Tutorial"
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            lg={4}
            md={6}
            xs={12}
          >
            <TutorialCardPreview
              ref={inputRef}
              tutorial={tutorial}
              hasImage={hasImage}
              onUpload={handleUploadImage}
            />
          </Grid>
          <Grid
            item
            lg={8}
            md={6}
            xs={12}
          >
            <CreateTutorialForm
              ref={inputRef}
              edit={edit}
              hasImage={hasImage}
              tutorial={tutorial}
              onChange={handleStateAttributes}
            />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

CreateTutorialView.propTypes = {
  edit: PropTypes.bool,
};

CreateTutorialView.defaultProps = {
  edit: false
};

export default CreateTutorialView;
